// src/components/SocialLogin.jsx
import React from 'react';

const SocialLogin = () => {

  const googleLogin = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENTID;
    const redirectUri = process.env.REACT_APP_REDIRECT_GOOGLE_URI; // O el que uses
    const scope = 'profile email';
    const responseType = 'code';

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&access_type=offline&prompt=consent`;

    window.location.href = authUrl;
  };

  const facebookLogin = () => {
    const clientId = `${process.env.REACT_APP_FACEBOOK_CLIENTID}`; // Reemplazar con el real
    const redirectUri = `${process.env.REACT_APP_REDIRECT_FACEBOOK_URI}`;
    const scope = 'email,public_profile';

    const authUrl = `https://www.facebook.com/v18.0/dialog/oauth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&response_type=code&auth_type=rerequest`;

    window.location.href = authUrl;
  };

  return (
    <div className="flex flex-col items-center space-y-4">
      <button
        onClick={googleLogin}
        className="inline-flex h-10 w-full items-center justify-center gap-2 rounded border border-slate-300 bg-white p-2 text-sm font-medium text-black outline-none focus:ring-2 focus:ring-[#333] focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-60"
      > <img
      src="https://www.svgrepo.com/show/475656/google-color.svg" alt="Google"
      className="h-[18px] w-[18px] "/>Continuar con
  Google
       
      </button>

      <button
        onClick={facebookLogin}
        className="inline-flex h-10 w-full items-center justify-center gap-2 rounded border border-slate-300 bg-white p-2 text-sm font-medium text-black outline-none focus:ring-2 focus:ring-[#333] focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-60">
         <img
                    src="https://www.svgrepo.com/show/448224/facebook.svg" alt="Google"
                    className="h-[18px] w-[18px] "/>Continuar con
                Facebook
      </button>

      {/* Facebook lo agregamos después con otro flow */}
    </div>
  );
};

export default SocialLogin;